import { render } from "./CheckoutFormStep2.vue?vue&type=template&id=a48f8b6e"
import script from "./CheckoutFormStep2.vue?vue&type=script&lang=js"
export * from "./CheckoutFormStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__